import React, { useState, useEffect } from 'react';
import { getActivationURL } from '../../Services/getActivationURL';
import DisneyPlusError from './DisneyPlusError';
import { translations } from '../Text/translations';
import disneyActivationEn from '../../assets/disneyplus/DisneyPlus_Activation_visual_en.png';
import disneyActivationTc from '../../assets/disneyplus/DisneyPlus_Activation_visual_tc.png';

const DisneyPlusNotActivated = ({ currentLang, nickname, mobilenowid, emailnowid, fsa, fsaType }) => {
  const [responseError, setResponseError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleActivateButtonClick = () => {
    if (!loading) {
      setLoading(true);
      Promise.all([
        getActivationURL('D+')
      ]).then(([activationResponse]) => {
        if (activationResponse.url) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'partner': 'disneyplus',
            'fsa_type': (fsaType || '').toLowerCase(),
            'click_location': 'partner_landing_page',
            'event': 'partner_activation_click'
          });
          window.location.href = activationResponse.url;
          setLoading(false);
        } else {
          setResponseError(true);
          setLoading(false);
        }
      }).catch((error) => {
        setResponseError(true);
        setLoading(false);
      });
    }
  };

  return (
    <>
      {responseError && (
        <DisneyPlusError
          currentLang={currentLang}
          nickname={nickname}
          mobilenowid={mobilenowid}
          emailnowid={emailnowid}
        />
      )}
      {!responseError && (
        <>
          <div className="name">
            <h2 className="name">{translations[currentLang].disneyplusSubjectGreeting}{nickname || mobilenowid || emailnowid}{translations[currentLang].disneyplusSubjectGreeting2}</h2>
          </div>
          <div className="message">
            <p>{translations[currentLang].disneyplusNotActivated}</p>
            <br />
            <p>{translations[currentLang].disneyplusRedirectRemark}</p>
          </div>
          <div className="cta-buttons">
            <button className="btn primary" onClick={handleActivateButtonClick}>
              {translations[currentLang].activiateDisneyplusAccount}
            </button>
          </div>
          <div className="preview-img">
            <img src={currentLang === 'en' ? disneyActivationEn : disneyActivationTc} alt="" />
          </div>
        </>
      )}
    </>
  );
};

export default DisneyPlusNotActivated;